import { makeObservable, observable } from "mobx";

class ResourcesStore {
  grantees = [];
  granteesLoading = false;
  folderPrivileges = [
    { entityPrivilegeUuid: "1", privilegeName: "User" },
    { entityPrivilegeUuid: "2", privilegeName: "Group Manager" },
    { entityPrivilegeUuid: "3", privilegeName: "Department Admin" },
  ];
  documentPrivileges = [
    { entityPrivilegeUuid: "1", privilegeName: "User" },
    { entityPrivilegeUuid: "2", privilegeName: "Group Manager" },
    { entityPrivilegeUuid: "3", privilegeName: "Department Admin" },
  ];

  constructor() {
    makeObservable(this, {
      grantees: observable,
      granteesLoading: observable,
      folderPrivileges: observable,
      documentPrivileges: observable,
    });
  }
}

export default ResourcesStore;
